var map = {
	"./Passport.svg": 2679,
	"./backpack.svg": 10,
	"./bag.svg": 935,
	"./bg.png": 7362,
	"./bg1.png": 5367,
	"./bg_mobile.png": 5839,
	"./bg_pc.png": 1127,
	"./btn_go.png": 6597,
	"./camera.svg": 4092,
	"./cash.svg": 530,
	"./credit-card.svg": 3578,
	"./culturetur.svg": 4895,
	"./ekotur.svg": 5297,
	"./go.svg": 9994,
	"./guide.svg": 3376,
	"./guide_block.gif": 4433,
	"./health.gif": 6621,
	"./infrastructure/astrakhan/astrakhan_aero.png": 6366,
	"./infrastructure/astrakhan/astrakhan_kreml.png": 300,
	"./infrastructure/astrakhan/astrakhan_teatr.png": 8631,
	"./infrastructure/astrakhan/azimut.png": 2746,
	"./infrastructure/barnaul/barnaul_aero.png": 3958,
	"./infrastructure/barnaul/barnaul_hotel.png": 7895,
	"./infrastructure/barnaul/kgbu.png": 2401,
	"./infrastructure/barnaul/teatr_barnaul.png": 7060,
	"./infrastructure/kazan/gavan.png": 3572,
	"./infrastructure/kazan/kazan_aero.png": 6328,
	"./infrastructure/kazan/kazan_ermitazh.png": 1643,
	"./infrastructure/kazan/kazan_zhd.png": 4766,
	"./infrastructure/moscow/domododevo.png": 5453,
	"./infrastructure/moscow/kreml.png": 5938,
	"./infrastructure/moscow/muzei_zapovednik.png": 7625,
	"./infrastructure/moscow/radisson.jpg": 9737,
	"./infrastructure/samara/lotte.png": 166,
	"./infrastructure/samara/samara_aero.png": 1831,
	"./infrastructure/samara/samara_kos.png": 3897,
	"./infrastructure/samara/samara_zhd.png": 3305,
	"./infrastructure/simferopol/muzei_zapovednik.png": 9377,
	"./infrastructure/simferopol/simferopol_aero.png": 1657,
	"./infrastructure/simferopol/simferopol_hotel.png": 5531,
	"./infrastructure/simferopol/simferopol_zhd.png": 3092,
	"./location.svg": 8465,
	"./logo_yaft.png": 4876,
	"./moon.png": 158,
	"./peshotur.svg": 2158,
	"./phone.svg": 7491,
	"./pods.svg": 1261,
	"./route.svg": 7506,
	"./settings.svg": 462,
	"./talon.svg": 945,
	"./ticket.svg": 4887,
	"./type/cultural/kazan/dvorets.png": 2296,
	"./type/cultural/kazan/kazan_kreml.png": 7442,
	"./type/cultural/kazan/spasskaya_bashnya.png": 165,
	"./type/cultural/samara/dacha_kupsa.png": 6765,
	"./type/cultural/samara/naberezhnaya.png": 3797,
	"./type/cultural/samara/ploshad.png": 25,
	"./type/cycle/moscow/art_park.jpg": 6519,
	"./type/cycle/moscow/priokskie_prostori.jpg": 9268,
	"./type/cycle/moscow/tberskoy_gubernii.jpg": 2738,
	"./type/eco/samara/botanicheskiy.png": 4018,
	"./type/eco/samara/zagorodniy.png": 4899,
	"./type/eco/samara/zigulevskiy_zapovednik.png": 9537,
	"./type/hiking/astrakhan/puteshestvie_po_astrakhan.jpg": 1749,
	"./type/hiking/astrakhan/splav_astrakhan.jpg": 4146,
	"./type/hiking/barnaul/181225_350x280.jpg": 600,
	"./type/hiking/barnaul/189789_350x280.jpeg": 5102,
	"./type/hiking/barnaul/bolshoe_puteshestvie.jpg": 3132,
	"./type/hiking/barnaul/shavlinskoe_ozera.jpeg": 889,
	"./type/hiking/simferopol/gori_krim.jpg": 4578,
	"./type/hiking/simferopol/krim.jpg": 3136,
	"./type/hiking/simferopol/sudak.jpg": 5073,
	"./usb.svg": 2456,
	"./user.svg": 6743,
	"./velotur.svg": 8969,
	"./weather.svg": 7236,
	"./weatherPage.gif": 4562,
	"./weather_block.png": 6050,
	"./Облачко.svg": 2996
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5459;